import React from 'react';
import './matimediaIntoduction.css';
import { FormattedMessage } from 'react-intl';

export function MatimediaIntoduction() {
  return (
    <div className="matimedia">
      <div className="matimedia-icon">
        <img src="./img/react_1x.png" alt="react1x" />
      </div>
      <div className="matimedia-background">
        <div className="matimedia-intoduction">
          <div className="matimedia-intoduction-title">
            <FormattedMessage id="multimediaTitle" />
            <div className="matimedia-intoduction-line"></div>
          </div>
          <div className="matimedia-intoduction-content">
            <p>
              <FormattedMessage id="multimediaContent1" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
